import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarSquareRegularActivityIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.75 2.476c.416 0 .75.334.75.75v1.25h5v-1.25c0-.416.334-.75.75-.75s.75.334.75.75v1.25h1c1.103 0 2 .897 2 2v9c0 1.103-.897 2-2 2H5c-1.103 0-2-.897-2-2v-9c0-1.103.897-2 2-2h1v-1.25c0-.416.334-.75.75-.75Zm8.25 13.5c.275 0 .5-.225.5-.5v-2h-2.75v2.5H15Zm.5-4v-2.5h-2.75v2.5h2.75Zm-4.25 0v-2.5h-2.5v2.5h2.5Zm-4 0v-2.5H4.5v2.5h2.75Zm-2.75 1.5v2c0 .275.225.5.5.5h2.25v-2.5H4.5Zm4.25 0v2.5h2.5v-2.5h-2.5Zm-2-7.5H5c-.275 0-.5.225-.5.5v1.5h11v-1.5c0-.275-.225-.5-.5-.5H6.75Z" })
});
export default SvgCalendarSquareRegularActivityIcon;
